import React from 'react';
import { View } from 'react-navi';
import { mount, compose, withView, redirect } from 'navi';
import ReactGA from 'react-ga';
import ProfileApp from './profiles';
import ListApp from './list';

const apps = compose(
  withView((request: any) => {
    if (process.env.REACT_APP_CONTEXT === 'production') {
      ReactGA.pageview(request.path);
    }
    return <View />;
  }),
  mount({
    '/': redirect('/list'),
    '/list': ListApp,
    '/entry': ProfileApp,
  }),
);

export default apps;
